"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const Hamburger_1 = __importDefault(require("../../assets/icons/Hamburger"));
const components_1 = require("../../components");
const ModalMenu_1 = __importDefault(require("../../components/modal/ModalMenu"));
const masterData_1 = require("../../utils/masterData");
const scale_1 = require("../../utils/scale");
const components_2 = require("./components");
const PolicyScreen = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                alignSelf: "center",
            }, title: "各種ポリシー・利用規約", styleContainer: {
                backgroundColor: "white",
            }, leftIcon: react_1.default.createElement(Hamburger_1.default, null), onLeftPress: () => {
                setVisibleMenu(true);
            } }),
        react_1.default.createElement(react_native_1.ScrollView, { contentContainerStyle: [
                styles.body, {
                    paddingBottom: inset.bottom + (0, scale_1.scale)(100)
                }
            ], showsVerticalScrollIndicator: false }, masterData_1.masterPolicies.map((item, index) => (react_1.default.createElement(components_2.PolicyItem, { key: index, data: item, index: index })))),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) })));
};
exports.default = PolicyScreen;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#f7f7f7'
    },
    body: {
        paddingTop: (0, scale_1.scale)(24)
    }
});
